import { h, defineComponent, ref, watch } from 'vue';
import { IdProps } from '@/ui/helpers/uiHelper';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { renderAnalyticsTeaserPage } from '@/ui/pages/teasers/AnalyticsTeaserPage';
import { renderForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
import { useTask } from '@/ui/concerns';
import { checklistInspections } from '@/services/api/resources/analytics';
import { container, loader } from '@/ui/components';
import ExplainChecklist from '@/_legacy/views/Analytics/Checklist/ExplainChecklist.vue';
import * as qs from '@/ui/queryState';

export const SummaryChecklistsExplainPage = defineComponent<IdProps>({
  name: 'SummaryChecklistsExplainPage',
  props: ['id'],
  setup(props) {
    if (!hasFeature('analytics')) {
      return renderAnalyticsTeaserPage;
    }

    if (!hasPermission(Permissions.VIEW_ALL_ANALYTICS)) {
      return renderForbiddenPage;
    }

    // create empty record
    const record = ref<unknown>();
    const uuid = qs.string('uuid', '');
    const response = qs.string('response', '');
    const type = qs.string('type', '');

    // get record
    const getRecord = useTask(
      () => checklistInspections(props.id, {
        uuid: uuid.value,
        response: response.value,
        type: type.value,
      }),
      data => {
        record.value = data.parsed;
      },
    );
    watch(ref(props.id), getRecord.run);

    return function render() {
      return h('div', [
        h('div', [
          container(
            [
              loader('div', getRecord, [
                record.value ? h(ExplainChecklist, {
                  class: 'legacy',
                  props: {
                    record: record.value,
                  },
                }) : null,
              ], false),
            ],
          ),
        ]),
      ]);
    };
  },
});
